import styles from "./styles.module.scss";

// TODO(tom): this section is tbd.
// See https://www.figma.com/file/OHazgwicFECMz16OWMXisQ?node-id=55:41170#235272025.
function Faq() {
  return <section className={styles["faq-section"]} />;
}

export default Faq;
